import * as actionTypes from './actionTypes';
import axios from '../../../global/axios';
import logger from '../../../global/logger';

export const fetchAuthStatus = () => {
    return dispatch => {
        dispatch({ type: actionTypes.FETCH_PCO_AUTH_STATUS_START });

        axios.get('/slides/pco_songs/auth_status.json')
        .then(res => {
            dispatch({ type: actionTypes.FETCH_PCO_AUTH_STATUS_SUCCESS, data: res.data });
        })
        .catch(err => {
            dispatch({ type: actionTypes.FETCH_PCO_AUTH_STATUS_FAILURE, error: err });
            logger.log(err);
        });
    }
};

export const fetchSongs = (offset = 0, query = '') => {
    return dispatch => {
        dispatch({ type: actionTypes.FETCH_PCO_SONGS_START, append: offset > 0 });

        let url = '/slides/pco_songs/songs.json?offset=' + offset;
        if (query) {
            url += '&q=' + encodeURIComponent(query);
        }

        axios.get(url)
        .then(res => {
            dispatch({ type: actionTypes.FETCH_PCO_SONGS_SUCCESS, data: res.data, append: offset > 0 });
        })
        .catch(err => {
            dispatch({ type: actionTypes.FETCH_PCO_SONGS_FAILURE, error: err });
            logger.log(err);
        });
    }
};

export const exportSong = (songId, arrangementIndex, formatType, songTitle) => {
    return dispatch => {
        axios.post('/slides/pco_songs/export', {
            song_id: songId,
            arrangement_index: arrangementIndex,
            format_type: formatType
        }, {
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json' }
        })
        .then(res => {
            const ext = formatType === 'pro' ? '.pro' : '.proBundle';
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', songTitle + ext);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        })
        .catch(err => {
            alert("Export failed. Please try again.");
            logger.log(err);
        });
    }
};

export const fetchSongDetail = (songId) => {
    return dispatch => {
        dispatch({ type: actionTypes.FETCH_PCO_SONG_DETAIL_START });

        axios.get('/slides/pco_songs/song/' + songId + '.json')
        .then(res => {
            dispatch({ type: actionTypes.FETCH_PCO_SONG_DETAIL_SUCCESS, data: res.data });
        })
        .catch(err => {
            dispatch({ type: actionTypes.FETCH_PCO_SONG_DETAIL_FAILURE, error: err });
            logger.log(err);
        });
    }
};
